module.exports = __webpack_public_path__ + "static/image 6-5baa9a1547ed2b7b4e45d33e9bc975cf.png";